import { queueTask, generateEventID } from '@sbt-web/utils';

/** Queue sending an event to GTM */
function sendEventToGTM(event, data = {}) {
    queueTask(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event,
            ss_event_id: generateEventID(),
            ...data,
        });
    }, 'background');
}
/** Queue sending the initialization event to GTM */
function sendInitEventToGTM() {
    queueTask(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ss_event_id: generateEventID(),
        });
    }, 'background');
    sendGTMLoadEvent();
}
const sendGTMLoadEvent = () => {
    window.didomiOnReady = window.didomiOnReady ?? [];
    window.didomiOnReady.push(() => {
        // Little delay to ensure that the data layer is ready
        window.setTimeout(() => {
            sendEventToGTM('subito_load');
        }, 50);
    });
};

export { sendEventToGTM, sendInitEventToGTM };
//# sourceMappingURL=gtm.js.map
